<template>
    <div>
        <b-form-group label="attestati"
                      label-size="sm"
                      :label-cols-sm="1"
                      :description="`Set value or FDO reference.`">
            <b-form-input size="sm"
                          v-model="value[1]"></b-form-input>
        </b-form-group>
        <b-form-group label="Number of years"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-input size="sm"
                          v-model.number="value[0]"
                          type="number"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
